var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlide3Home(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80.186,
    height: 80,
    viewBox: "0 0 80.186 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14941",
    "data-name": "Rectangle 14941",
    width: 80.186,
    height: 80,
    fill: "#909090"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2690",
    "data-name": "Group 2690",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21235",
    "data-name": "Path 21235",
    d: "M476.468,273.866c16.008-1.666,24.8-10.587,26.555-26.535,7.419,1.574,13.732,11.063,13.338,20.181-.436,10.079-8.668,18.576-19.107,19.722-8.707.956-18.493-5.268-20.787-13.368",
    transform: "translate(-436.192 -226.424)",
    fill: "#040e62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21236",
    "data-name": "Path 21236",
    d: "M13.5,265.788C6.078,264.158-.313,254.715.011,246.3c.4-10.417,7.852-18.589,18.469-20.255,8.966-1.407,18.372,4.314,21.571,13.272-7.119.41-13.464,2.662-18.587,7.749-5.142,5.106-7.493,11.439-7.964,18.725",
    transform: "translate(0.001 -206.741)",
    fill: "#040e62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21237",
    "data-name": "Path 21237",
    d: "M269.944.165c9.045,1.1,17.022,9.448,17.641,18.461.673,9.791-5.04,19.023-13.226,21.218-1.634-15.963-10.427-24.835-26.606-26.531,2.924-8.864,12.3-14.352,22.19-13.148",
    transform: "translate(-226.811 0)",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21238",
    "data-name": "Path 21238",
    d: "M249.695,515.1a21.018,21.018,0,0,1-21.371-18.74c-1-9.247,5.279-19.2,13.293-21.084.831,16.007,13.019,26.024,26.342,26.372-.5,5.451-9.151,13.4-18.264,13.453",
    transform: "translate(-208.928 -435.104)",
    fill: "#f6f5fa"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlide3Home);
export default __webpack_public_path__ + "static/media/slide3_home.231750c8ea34a0653e51414f0e4b1c4f.svg";
export { ForwardRef as ReactComponent };